function NavMenu() {
	const navMenuItems = document.querySelectorAll('.dropdown-toggle');

	if (navMenuItems && !navMenuItems.isEmpty()) {
	    [...navMenuItems].map((nav) => {
	        const dropdown = nav.parentNode.querySelector('.dropdown-menu');

	        nav.addEventListener('click', (e) => handleDropdown(navMenuItems, dropdown, e));
	        nav.addEventListener('touchstart', (e) => handleDropdown(navMenuItems, dropdown, e));

	        function handleDropdown (navMenuItems, dropdown, e) {
	            e.preventDefault();

	            // Close the other navigation menus
	            [...navMenuItems].map((tempNavigationItem) => {
	                const tempDropdown = tempNavigationItem.parentNode.querySelector('.dropdown-menu');

	                // Ignore the node if its the one that is supposed to be open
	                if (!tempDropdown.isSameNode(dropdown)) {
	                    tempDropdown.classList.remove('show');
	                    tempDropdown.setAttribute('aria-expanded', false);
	                }
	            });

	            // Open the dropdown
	            if (dropdown.classList.contains('show')) {
	                dropdown.setAttribute('aria-expanded', false);
	                dropdown.classList.remove('show');
	            } else {
	                // Otherwise close it
	                dropdown.setAttribute('aria-expanded', true);
	                dropdown.classList.add('show');
	            }
	        }
	    });
	}

	var ddMenu = document.querySelector('.dropdown-menu');

	if ( ddMenu ) {
		//Adds keyboard accessibility to dropdown submenus
		ddMenu.onkeydown = function (evt) {
			var $this = $(this);
			switch(evt.keyCode) {
				case 13: // Enter key
				case 32: // Space bar
				case 38: // Up arrow
				case 40: // Down arrow
					$this.find('.dropdown-menu').addClass("show");
					$this.find('.dropdown-menu li:first').focus();
					break;
				case 27: // Escape key
					$this.find('.dropdown-menu').removeClass("show");
					$this.focus();
					break;
			}
		};

		var ddMenuItems = document.querySelector('.dropdown-menu a');

		ddMenuItems.onkeydown = function (evt) {
			var $this = $(this);

			// function select_previous () {
			// 	if( $this.prev('a')[0] ) {
			// 		$this.prev().focus();
			// 		evt.stopPropagation();
			// 	} else {
			// 		$this.parent().removeClass("show");
			// 	}
			// }
			//
			// function select_next () {
			// 	if( $this.next('li')[0] ) {
			// 		$this.next().focus();
			// 		evt.stopPropagation();
			// 	} else {
			// 		$this.parent().removeClass("show");
			// 	}
			// }

			switch(evt.keyCode) {
				case 13: // Enter key
					$this.click();
					$this.parent().removeClass('show');
					evt.stopPropagation();
					break;
				case 32: // Space bar
					$this.click();
					$this.parent().removeClass('show');
					evt.stopPropagation();
					break;
				// case 9: // Tab key
				// 	if (evt.shiftKey) {
				// 		select_previous();
				// 	}
				// 	else {
				// 		select_next();
				// 	}
				// 	evt.preventDefault();
				// 	break;
				case 38: // Up arrow
					select_previous();
					break;
				case 40: // Down arrow
					select_next();
					break;
				}
		};
	}

	// Handle mobile menu clicks
	const mobileMenuBtn = document.getElementById('mobileMenuBtn');
	var target = document.querySelector(mobileMenuBtn.dataset.target);
	mobileMenuBtn.addEventListener('click', function(e){
	    var display = target.style.display;
	    if ( display !== 'block' ) {
	        target.style.display = 'block';
	        target.classList.add('mobile');
	    } else {
	        target.style.display = 'none';
	        target.classList.remove('mobile');
	    }
	});
	// Handle mobile menu responsive display
	var x = window.matchMedia("(max-width: 1199px)");
	windowResize(x);
	x.addListener(windowResize);
	function windowResize(x) {
	    if (x.matches) {
	        // Do responive stuff
	        target.style.display = 'none';
	    } else {
	        // Do non-responsive stuff
	        target.style.display = 'block';
	    }
	}
}

export default NavMenu;
